export default "__VITE_ASSET__BClW_yJv__"